import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/api";
import { Card } from "./ui/card";
import { Star, MessageSquare } from "lucide-react";

/**
 * PublicReviewsWall — top 3 highest-rated recent comments for a doctor.
 * Renders NOTHING when the doctor has no eligible reviews yet, so the
 * profile page keeps its clean layout on day one.
 */
export default function PublicReviewsWall({ doctorId }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!doctorId) return;
    axios.get(`${API}/public/doctors/${doctorId}/reviews?limit=3&min_rating=4`)
      .then((r) => setRows(r.data || []))
      .catch(() => setRows([]));
  }, [doctorId]);

  if (!rows || rows.length === 0) return null;

  return (
    <Card className="medical-card p-5 sm:p-6" data-testid="public-reviews-wall">
      <div className="flex items-center gap-2 mb-3">
        <MessageSquare className="w-4 h-4 text-amber-500" />
        <h2 className="font-heading text-lg font-semibold text-slate-900">Patient reviews</h2>
        <span className="ml-auto text-xs text-slate-400">verified feedback</span>
      </div>
      <div className="grid md:grid-cols-3 gap-3">
        {rows.map((r, i) => (
          <div
            key={i}
            className="rounded-xl border border-amber-200 bg-gradient-to-br from-amber-50/50 to-white p-3"
            data-testid={`review-card-${i}`}
          >
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-amber-500 text-white text-xs font-bold flex items-center justify-center">
                {r.initials}
              </div>
              <div className="flex items-center gap-0.5">
                {[1,2,3,4,5].map((s) => (
                  <Star key={s} className={`w-3 h-3 ${s <= r.rating ? "text-amber-500 fill-amber-400" : "text-slate-300"}`} />
                ))}
              </div>
              <span className="ml-auto text-[10px] text-slate-400">{r.created_at?.slice(0, 10)}</span>
            </div>
            <p className="text-sm text-slate-700 mt-2 line-clamp-4">{r.comment}</p>
          </div>
        ))}
      </div>
    </Card>
  );
}
